// Кнопка «синхронизировать Garmin» в шапке «Сегодня»: обновляет сон, готовность, шаги и
// активности сразу, не дожидаясь задания worker (раз в 30 минут). На кнопке — время последней
// удачной синхронизации. Без подключения не показывается: про вход говорит плашка Garmin.

import { Button, useToast } from '@/components/ui'
import { formatDateTime, formatTime } from '@/lib/format'
import { useGarminStatus, useGarminSync } from '@/pages/settings/garmin/api'
import { needsLogin } from '@/pages/settings/garmin/logic'

function lastSyncLabel(iso: string | null): string | null {
  if (!iso) return null
  const at = new Date(iso)
  return at.toDateString() === new Date().toDateString() ? formatTime(at) : formatDateTime(at)
}

export function GarminSyncButton() {
  const status = useGarminStatus()
  const sync = useGarminSync()
  const toast = useToast()
  if (needsLogin(status.data)) return null

  const last = lastSyncLabel(status.data?.last_success_at ?? null)
  const label = last ? `Синхронизировать Garmin (последняя — ${last})` : 'Синхронизировать Garmin'
  return (
    <Button
      icon="refresh"
      aria-label={label}
      title={label}
      className="max-sm:w-11 max-sm:px-0!"
      loading={sync.isPending || status.data?.syncing === true}
      onClick={() =>
        sync.mutate(undefined, {
          onSuccess: (run) =>
            toast.show({
              message: run.status === 'ok' ? 'Garmin синхронизирован' : (run.error ?? 'Синхронизация не удалась'),
              tone: run.status === 'ok' ? 'accent' : undefined,
            }),
          onError: (error) => toast.show({ message: error.message }),
        })
      }
    >
      <span className="hidden sm:inline">Garmin</span>
      {last ? <span className="hidden tabular-nums text-muted sm:inline">{last}</span> : null}
    </Button>
  )
}
